import { Component, Input } from '@angular/core';
import { CurrentUser } from '../../models/user.model';
import { TicketInfo, ReservationInfo } from '../../pages/event-ticket/event-ticket.model';

/**
 * Generated class for the EventTicketItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'event-ticket-item',
  templateUrl: 'event-ticket-item.html'
})
export class EventTicketItemComponent {

  @Input() user: CurrentUser; 
  @Input() ticketInfo: ReservationInfo; 

  constructor() {
  }

  shortTitle(element): number {
    let height = element.offsetHeight;
    return height;
  }

}



// WEBPACK FOOTER //
// ./src/components/event-ticket-item/event-ticket-item.ts